import { render, staticRenderFns } from "./saleRecordCert.vue?vue&type=template&id=18778c82&scoped=true"
import script from "./saleRecordCert.vue?vue&type=script&lang=js"
export * from "./saleRecordCert.vue?vue&type=script&lang=js"
import style0 from "./saleRecordCert.vue?vue&type=style&index=0&id=18778c82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18778c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18778c82')) {
      api.createRecord('18778c82', component.options)
    } else {
      api.reload('18778c82', component.options)
    }
    module.hot.accept("./saleRecordCert.vue?vue&type=template&id=18778c82&scoped=true", function () {
      api.rerender('18778c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/components/saleRecordCert.vue"
export default component.exports